import {Component} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ICellRendererParams} from 'ag-grid-community';
import {PermissionType} from "../../../../components/employee/PermissionType.enum";

export interface EducationIndividualActionsContext {
    userRole: string;
    viewDialog: (element: any) => void;
    viewEdit: (element: any) => void;
    delete: (element: any) => void;
    changeStatus: (element: any) => void;
    toggleHighlight: (element: any) => void;
}

@Component({
    selector: 'app-education-individual-actions-renderer',
    templateUrl: './education-individual-actions-renderer.component.html',
    styleUrls: ['./education-individual-actions-renderer.component.scss']
})
export class EducationIndividualActionsRendererComponent implements ICellRendererAngularComp {
    private params!: ICellRendererParams & { context: EducationIndividualActionsContext };
    protected readonly PermissionType = PermissionType;

    agInit(params: ICellRendererParams & { context: EducationIndividualActionsContext }): void {
        this.params = params;
    }

    refresh(params: ICellRendererParams & { context: EducationIndividualActionsContext }): boolean {
        this.params = params;
        return true;
    }

    get element(): any {
        return this.params.data;
    }

    get context(): EducationIndividualActionsContext {
        return this.params.context;
    }
}
